import {subscribeToChannel, unsubscribeToChannel} from "../services/pusher";
import api from "../api";
import pusherHelper from "../services/pusherHelper";
import dates from "../services/dates";

const state = {
  selectedDate: null,
  calendarList: [],
  todayList: [],
};

const getters = {
  calendarList(state) {
    let appointments = [...state.calendarList]
    return appointments.sort((a, b) => new Date(a.start_at) - new Date(b.start_at))
  },
  todayList(state) {
    let appointments = [...state.todayList]

    // this is here to handle appointments pushed by Pusher Events
    return appointments.filter(appointment => dates.isDateEqual(appointment.start_at, state.selectedDate))
      .sort((a, b) => new Date(a.start_at) - new Date(b.start_at))
  },
};

const mutations = {
  updateSelectedDate(state, date) {
    state.selectedDate = date
  },
  setupCalendarList(state, data) {
    state.calendarList = data
  },
  setupTodayList(state, data) {
    state.todayList = data
  },
  updateAppointmentCollection(state, data) {
    state.calendarList = pusherHelper.updateCollection(state.calendarList, data)
    state.todayList = pusherHelper.updateCollection(state.todayList, data)
  },
  teardown(state) {
    state.selectedDate = null
    state.calendarList = []
    state.todayList = []
  },
};

const actions = {
  setupCalendarList({commit, state, rootGetters}, selectedDate) {
    return api.clientStore.initDashboardAppointments(selectedDate, 'month').then(response => {
      commit('setupCalendarList', response.data)
    })
  },
  setupTodayList({commit, state, rootGetters}, selectedDate) {
    return api.clientStore.initDashboardAppointments(selectedDate, 'today').then(response => {
      commit('updateSelectedDate', selectedDate)
      commit('setupTodayList', response.data)
    })
  },
  processPusherEvent({commit, dispatch}, payload) {
    commit("updateAppointmentCollection", payload)
  },
  tearDown({commit, state, rootGetters, getters}) {
    commit('teardown')
  },
};

const DashboardAppointments = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default DashboardAppointments;
